var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#F2D9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06066 10.9393C7.47487 10.3536 6.52513 10.3536 5.93934 10.9393C5.35355 11.5251 5.35355 12.4749 5.93934 13.0607L8.06066 10.9393ZM10.5 15.5L9.43934 16.5607C10.0251 17.1464 10.9749 17.1464 11.5607 16.5607L10.5 15.5ZM18.0607 10.0607C18.6464 9.47487 18.6464 8.52513 18.0607 7.93934C17.4749 7.35355 16.5251 7.35355 15.9393 7.93934L18.0607 10.0607ZM5.93934 13.0607L9.43934 16.5607L11.5607 14.4393L8.06066 10.9393L5.93934 13.0607ZM11.5607 16.5607L18.0607 10.0607L15.9393 7.93934L9.43934 14.4393L11.5607 16.5607Z",
    fill: "#963695"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H20V-2H4V2ZM22 4V20H26V4H22ZM20 22H4V26H20V22ZM2 20V4H-2V20H2ZM4 22C2.89543 22 2 21.1046 2 20H-2C-2 23.3137 0.686292 26 4 26V22ZM22 20C22 21.1046 21.1046 22 20 22V26C23.3137 26 26 23.3137 26 20H22ZM20 2C21.1046 2 22 2.89543 22 4H26C26 0.686291 23.3137 -2 20 -2V2ZM4 -2C0.686291 -2 -2 0.686292 -2 4H2C2 2.89543 2.89543 2 4 2V-2Z",
    fill: "#963695"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.3ba2a47c84ee02155613dfc8f973df7c.svg";
export { ForwardRef as ReactComponent };